import React, { useEffect, useState } from 'react';
import { useStore } from '../state/store';
import { d001Surfacing } from '../lib/operatingMode';
import { planNeedsSetup, orgPipelineTabs } from '../lib/orgPlan';
import { Chip, Banner, Card, Empty } from '../components/ui';
import CommercialPipeline from './CommercialPipeline';
import Saudi from './Saudi';
import Infrastructure from './Infrastructure';

/**
 * Unified Pipeline shell — tabs from org plan named pipelines (preferred)
 * or workstreams with pipelineTab. Panel choice comes from pipeline.panel.
 */
export default function Pipeline({ go }) {
  const { state, d } = useStore();
  const needsSetup = planNeedsSetup(state);
  const tabs = orgPipelineTabs(state);
  const [tab, setTab] = useState('');
  const surfacing = d001Surfacing(d);

  useEffect(() => {
    if (!tabs.length) {
      setTab('');
      return;
    }
    if (!tabs.some((t) => t.key === tab)) {
      setTab(tabs[0].key);
    }
  }, [tabs, tab]);

  const activeTab = tabs.find((t) => t.key === (tab || tabs[0]?.key)) || tabs[0];
  const active = activeTab?.key || '';
  const panel = activeTab?.panel || 'commercial';
  const hasDeepWorkspace = !!activeTab?.deepWorkspace || !!activeTab?.pipeline?.deepWorkspace;

  if (needsSetup || !tabs.length) {
    return (
      <>
        <div className="page-head">
          <h2>Pipeline</h2>
          <div className="sub">Named commercial pipelines appear after you activate an organization plan.</div>
        </div>
        <section className="section">
          <Card title="Plan not set">
            <Empty title="No pipelines yet">
              Set up your organization plan on Strategy — choose a template, import a CSV, or pull Jira epics —
              then Pipeline tabs come from that plan&apos;s named pipelines.
            </Empty>
            <button type="button" className="btn primary" style={{ marginTop: 12 }} onClick={() => go('strategy')}>
              Set up plan
            </button>
          </Card>
        </section>
      </>
    );
  }

  return (
    <>
      <div className="page-head">
        <div className="row wrap" style={{ gap: 8 }}>
          <h2>Pipeline</h2>
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              className={`btn sm ${active === t.key ? 'primary' : 'ghost'}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
          <div className="spacer" />
          {hasDeepWorkspace && surfacing.showInPipeline && (
            <button type="button" className="btn sm" onClick={() => go('primary-deal')}>
              {surfacing.level === 'primary' ? 'Open primary deal workspace' : 'Deal candidates'}
            </button>
          )}
        </div>
        <div className="sub">
          {activeTab?.label || 'Commercial'} state. CRM opportunity objects stay unqualified until Bridge criteria are
          met.
        </div>
      </div>

      {(d.funnel?.counts?.observed || 0) > 0 && panel === 'commercial' && (
        <section className="section">
          <Banner>
            <Chip>{d.funnel.counts.observed}</Chip> CRM-observed opportunity shell(s) — not counted as qualified until
            problem + next step are confirmed.
          </Banner>
        </section>
      )}

      {panel === 'saudi' && <Saudi go={go} />}
      {panel === 'infrastructure' && <Infrastructure go={go} />}
      {panel !== 'saudi' && panel !== 'infrastructure' && activeTab && (
        <CommercialPipeline go={go} embedded pipeline={activeTab.pipeline || activeTab} />
      )}
    </>
  );
}
